import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecom-unauthorized',
  templateUrl: './ecom-unauthorized.component.html',
  styleUrls: ['./ecom-unauthorized.component.scss']
})
export class EcomUnauthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
